import type { DispenseIdentity } from './dispensePreset'

export function parseOpenInAppUrl (
  raw: string | null | undefined,
): DispenseIdentity | null {
  if (raw == null || raw.trim() === '') {
    return null
  }

  const identity = identityFromHref(raw)
  if (identity) {
    return identity
  }

  const embeddedIndex = raw.search(/https?:\/\//i)
  if (embeddedIndex > 0) {
    return identityFromHref(raw.slice(embeddedIndex))
  }

  return null
}

function identityFromHref (href: string): DispenseIdentity | null {
  let url: URL
  try {
    url = new URL(href)
  } catch {
    return null
  }

  if (!pathnameHasOiaSegment(url.pathname)) {
    return null
  }

  const nfcCode = url.searchParams.get('nfc_code')?.trim() ?? ''
  if (nfcCode === '') {
    return null
  }

  return { via: 'nfc', nfc_id: nfcCode }
}

function pathnameHasOiaSegment (pathname: string): boolean {
  return pathname.split('/').includes('oia')
}
